import { Edit, Visibility } from '@mui/icons-material';
import { Grid, IconButton, useEventCallback } from '@mui/material';
import { BodyNotificationStateVM } from 'practice/view-models/practice-detail';
import { Fragment, memo, ReactElement, useMemo, useState } from 'react';
import Table from 'shell/components/shared/table';
import { HeadCell } from 'shell/components/shared/table/types';
import { noop } from 'shell/utils/noop';
import ModalNotificationState from './modal-notification-state';
import { DateTime } from 'luxon';

interface TableNotificationStateProps {
  data?: Array<BodyNotificationStateVM>;
  disabled?: boolean;
  onEditPress?: (item: BodyNotificationStateVM) => void;
  onViewPress?: (item: BodyNotificationStateVM) => void;
  onDeletePress?: (item: BodyNotificationStateVM) => void;
  hideButtons?: boolean;
}

const headCellsAction: HeadCell<BodyNotificationStateVM, keyof BodyNotificationStateVM>[] = [
  {
    id: 'id',
    label: 'ID',
  },
  {
    id: 'date',
    label: 'Data',
  },
  {
    id: 'communicationType',
    label: 'Tipo Comunicazione',
  },
  {
    id: 'transmissionType',
    label: 'Tipo Trasmissione',
  },
  {
    id: 'state',
    label: 'Stato',
  },
  // {
  //   id: 'action',
  //   label: '',
  // },
];

const TableNotificationStateComponent = ({
  data,
  hideButtons = false,
  onViewPress = noop,
  onEditPress = noop,
}: // disabled,
TableNotificationStateProps): ReactElement => {
  const [tableProps, setTableProps] = useState({
    page: 0,
    rowsPerPage: 10,
  });

  const [openModal, setOpenModal] = useState<{
    open: boolean;
    title?: string;
    isEdit?: boolean;
    element?: BodyNotificationStateVM;
  }>({ open: false });

  // eslint-disable-next-line no-console
  console.log(data);

  const body: Array<BodyNotificationStateVM> = useMemo(() => {
    return (data || []).map((item) => {
      return {
        ...item,
        action: hideButtons ? undefined : (
          <Fragment>
            <IconButton
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onViewPress(item);
                setOpenModal({
                  open: true,
                  element: item,
                  title: `Visualizza Notifica ${item.id || ''}`,
                });
              }}
              aria-label="Visualizza elemento"
              aria-haspopup="true"
              style={{
                padding: '4px',
                borderRadius: '50%',
              }}
            >
              <Visibility />
            </IconButton>
            {item.hasEdit ? (
              <IconButton
                // disabled={disabled}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  onEditPress(item);
                  setOpenModal({
                    open: true,
                    element: item,
                    title: `Modifica Notifica ${item.id || ''}`,
                    isEdit: true,
                  });
                }}
                aria-label="Modifica elemento"
                aria-haspopup="true"
                style={{
                  padding: '4px',
                  borderRadius: '50%',
                }}
              >
                <Edit />
              </IconButton>
            ) : undefined}
          </Fragment>
        ),
      };
    });
  }, [data, onEditPress, onViewPress, setOpenModal]);

  const onChangePage = useEventCallback((page: number) => {
    setTableProps({
      page,
      rowsPerPage: tableProps.rowsPerPage,
    });
  });

  const onChangeRowsPerPage = useEventCallback((rowsPerPage: number) => {
    setTableProps({
      page: 0,
      rowsPerPage,
    });
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {body?.length > 0 ? (
          <Table
            ariaLabel="Lista stati pratiche"
            page={tableProps.page || 0}
            rowsPerPage={tableProps.rowsPerPage || 10}
            body={body}
            count={body?.length || 0}
            head={headCellsAction}
            onSort={noop}
            onPageChange={onChangePage}
            onRowsPerPageChange={onChangeRowsPerPage}
            orders={{}}
            isNotLayoutFixed
            noSort
            hideButtons
          />
        ) : (
          'Nessuna informazione'
        )}
      </Grid>
      {openModal.open ? (
        <ModalNotificationState
          open={openModal.open || false}
          title={openModal.title}
          onClose={() => setOpenModal({ open: false })}
          modalData={{
            address: openModal.element?.id || '',
            pecAddress: openModal.element?.communicationType || '',
            cap: openModal.element?.id || '',
            id: openModal.element?.id || '',
            communicationType: '',
            date: DateTime.now(),
            location: '',
            state: openModal.element?.state || '',
            surnameNameReceiver: '',
          }}
          isEdit={openModal.isEdit}
          onSubmit={() => {
            // TODO SOMETHING
            setOpenModal({ open: false });
          }}
        />
      ) : undefined}
    </Grid>
  );
};

TableNotificationStateComponent.displayName = 'Practice Research - Table Persons component';

const TableNotificationState = memo(TableNotificationStateComponent);

export default TableNotificationState;
